import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function resultadoexamenComboReducer(state= initialState.resultadoexamenCombo, action){
	switch(action.type){
		case types.GET_RESULTADOEXAMENS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}